import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { generateTokenFn } from './tokens';
export var border = {
  styles: function styles() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref.target,
        all = _ref.all,
        top = _ref.top,
        right = _ref.right,
        bottom = _ref.bottom,
        left = _ref.left;

    var widthShared = {
      target: target,
      tokenKey: 'border.width'
    };
    var styleShared = {
      target: target,
      base: function base() {
        return 'solid';
      },
      tokenKey: 'border.style'
    };
    var colorShared = {
      target: target,
      tokenKey: 'color.border'
    };
    var radiusShared = {
      target: target,
      tokenKey: 'border.radius'
    };

    var _ref2 = all || {},
        width = _ref2.width,
        style = _ref2.style,
        color = _ref2.color,
        radius = _ref2.radius;

    var _ref3 = top || {},
        topWidth = _ref3.width,
        topStyle = _ref3.style,
        topColor = _ref3.color,
        topRadius = _ref3.radius,
        topRight = _ref3.right,
        topLeft = _ref3.left;

    var _ref4 = topRight || {},
        topRightRadius = _ref4.radius;

    var _ref5 = topLeft || {},
        topLeftRadius = _ref5.radius;

    var _ref6 = right || {},
        rightWidth = _ref6.width,
        rightStyle = _ref6.style,
        rightColor = _ref6.color,
        rightRadius = _ref6.radius;

    var _ref7 = bottom || {},
        bottomWidth = _ref7.width,
        bottomStyle = _ref7.style,
        bottomColor = _ref7.color,
        bottomRadius = _ref7.radius,
        bottomRight = _ref7.right,
        bottomLeft = _ref7.left;

    var _ref8 = bottomRight || {},
        bottomRightRadius = _ref8.radius;

    var _ref9 = bottomLeft || {},
        bottomLeftRadius = _ref9.radius;

    var _ref10 = left || {},
        leftWidth = _ref10.width,
        leftStyle = _ref10.style,
        leftColor = _ref10.color,
        leftRadius = _ref10.radius;

    return {
      borderTopWidth: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
        type: ['border.top.width', 'border.width'],
        fallback: [topWidth, width]
      })),
      borderTopStyle: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
        type: ['border.top.style', 'border.style'],
        fallback: [topStyle, style]
      })),
      borderTopColor: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
        type: ['border.top.color', 'border.color'],
        fallback: [topColor, color]
      })),
      borderTopRightRadius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
        type: ['border.top.right.radius', 'border.top.radius', 'border.right.radius', 'border.radius'],
        fallback: [topRightRadius, topRadius, rightRadius, radius]
      })),
      borderTopLeftRadius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
        type: ['border.top.left.radius', 'border.top.radius', 'border.left.radius', 'border.radius'],
        fallback: [topLeftRadius, topRadius, leftRadius, radius]
      })),
      borderRightWidth: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
        type: ['border.right.width', 'border.width'],
        fallback: [rightWidth, width]
      })),
      borderRightStyle: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
        type: ['border.right.style', 'border.style'],
        fallback: [rightStyle, style]
      })),
      borderRightColor: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
        type: ['border.right.color', 'border.color'],
        fallback: [rightColor, color]
      })),
      borderBottomWidth: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
        type: ['border.bottom.width', 'border.width'],
        fallback: [bottomWidth, width]
      })),
      borderBottomStyle: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
        type: ['border.bottom.style', 'border.style'],
        fallback: [bottomStyle, style]
      })),
      borderBottomColor: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
        type: ['border.bottom.color', 'border.color'],
        fallback: [bottomColor, color]
      })),
      borderBottomRightRadius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
        type: ['border.bottom.right.radius', 'border.bottom.radius', 'border.right.radius', 'border.radius'],
        fallback: [bottomRightRadius, bottomRadius, rightRadius, radius]
      })),
      borderBottomLeftRadius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
        type: ['border.bottom.left.radius', 'border.bottom.radius', 'border.left.radius', 'border.radius'],
        fallback: [bottomLeftRadius, bottomRadius, leftRadius, radius]
      })),
      borderLeftWidth: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
        type: ['border.left.width', 'border.width'],
        fallback: [leftWidth, width]
      })),
      borderLeftStyle: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
        type: ['border.left.style', 'border.style'],
        fallback: [leftStyle, style]
      })),
      borderLeftColor: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
        type: ['border.left.color', 'border.color'],
        fallback: [leftColor, color]
      }))
    };
  },
  tokens: function tokens() {
    var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref11.target,
        all = _ref11.all,
        top = _ref11.top,
        right = _ref11.right,
        bottom = _ref11.bottom,
        left = _ref11.left;

    var widthShared = {
      target: target,
      tokenKey: 'border.width'
    };
    var styleShared = {
      target: target,
      base: function base() {
        return 'solid';
      },
      tokenKey: 'border.style'
    };
    var colorShared = {
      target: target,
      tokenKey: 'color.border'
    };
    var radiusShared = {
      target: target,
      tokenKey: 'border.radius'
    };

    var _ref12 = all || {},
        width = _ref12.width,
        style = _ref12.style,
        color = _ref12.color,
        radius = _ref12.radius;

    var _ref13 = top || {},
        topWidth = _ref13.width,
        topStyle = _ref13.style,
        topColor = _ref13.color,
        topRadius = _ref13.radius,
        topRight = _ref13.right,
        topLeft = _ref13.left;

    var _ref14 = topRight || {},
        topRightRadius = _ref14.radius;

    var _ref15 = topLeft || {},
        topLeftRadius = _ref15.radius;

    var _ref16 = right || {},
        rightWidth = _ref16.width,
        rightStyle = _ref16.style,
        rightColor = _ref16.color,
        rightRadius = _ref16.radius;

    var _ref17 = bottom || {},
        bottomWidth = _ref17.width,
        bottomStyle = _ref17.style,
        bottomColor = _ref17.color,
        bottomRadius = _ref17.radius,
        bottomRight = _ref17.right,
        bottomLeft = _ref17.left;

    var _ref18 = bottomRight || {},
        bottomRightRadius = _ref18.radius;

    var _ref19 = bottomLeft || {},
        bottomLeftRadius = _ref19.radius;

    var _ref20 = left || {},
        leftWidth = _ref20.width,
        leftStyle = _ref20.style,
        leftColor = _ref20.color,
        leftRadius = _ref20.radius;

    return {
      border: {
        top: {
          width: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
            type: ['border.top.width', 'border.width'],
            fallback: [topWidth, width]
          })),
          style: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
            type: ['border.top.style', 'border.style'],
            fallback: [topStyle, style]
          })),
          color: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
            type: ['border.top.color', 'border.color'],
            fallback: [topColor, color]
          })),
          right: {
            radius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
              type: ['border.top.right.radius', 'border.top.radius', 'border.right.radius', 'border.radius'],
              fallback: [topRightRadius, topRadius, rightRadius, radius]
            }))
          },
          left: {
            radius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
              type: ['border.top.left.radius', 'border.top.radius', 'border.left.radius', 'border.radius'],
              fallback: [topLeftRadius, topRadius, leftRadius, radius]
            }))
          }
        },
        right: {
          width: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
            type: ['border.right.width', 'border.width'],
            fallback: [rightWidth, width]
          })),
          style: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
            type: ['border.right.style', 'border.style'],
            fallback: [rightStyle, style]
          })),
          color: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
            type: ['border.right.color', 'border.color'],
            fallback: [rightColor, color]
          }))
        },
        bottom: {
          width: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
            type: ['border.bottom.width', 'border.width'],
            fallback: [bottomWidth, width]
          })),
          style: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
            type: ['border.bottom.style', 'border.style'],
            fallback: [bottomStyle, style]
          })),
          color: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
            type: ['border.bottom.color', 'border.color'],
            fallback: [bottomColor, color]
          })),
          right: {
            radius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
              type: ['border.bottom.right.radius', 'border.bottom.radius', 'border.right.radius', 'border.radius'],
              fallback: [bottomRightRadius, bottomRadius, rightRadius, radius]
            }))
          },
          left: {
            radius: generateTokenFn(_objectSpread(_objectSpread({}, radiusShared), {}, {
              type: ['border.bottom.left.radius', 'border.bottom.radius', 'border.left.radius', 'border.radius'],
              fallback: [bottomLeftRadius, bottomRadius, leftRadius, radius]
            }))
          }
        },
        left: {
          width: generateTokenFn(_objectSpread(_objectSpread({}, widthShared), {}, {
            type: ['border.left.width', 'border.width'],
            fallback: [leftWidth, width]
          })),
          style: generateTokenFn(_objectSpread(_objectSpread({}, styleShared), {}, {
            type: ['border.left.style', 'border.style'],
            fallback: [leftStyle, style]
          })),
          color: generateTokenFn(_objectSpread(_objectSpread({}, colorShared), {}, {
            type: ['border.left.color', 'border.color'],
            fallback: [leftColor, color]
          }))
        }
      }
    };
  }
};